import { Button, Group, Stack } from '@mantine/core';
import React from 'react';
import { connect } from 'react-redux';

import Response from '../../components/Response';
import TestCommand from '../../components/TestCommand';
import { getApiDevice, getLicenses } from '../../redux/actions/api';

const GetLicenses = ({ access, getLicenses }) => (
  <Stack>
    <Group>
      <Button onClick={() => getLicenses(access.id)} disabled={!access.id}>
        Get
      </Button>
      <span>
        Device ID:
        {access.id || 'Not set'}
      </span>
    </Group>

    {access.id && <TestCommand url={`/${access.id}/licenses`} />}

    <Response type="getLicenses" />
  </Stack>
);

const mapStateToProps = (state) => ({
  access: getApiDevice(state),
});

export default connect(mapStateToProps, { getLicenses })(GetLicenses);
